import styled from '@emotion/styled'

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 13px 30px 13px 50px;
  background-color: #fafafa;
  border-top: 1px solid #f2f2f2;
  border-bottom: 1px solid #e9e9e9;
  gap: 10px;
`
